import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { app, routes } from "../General";
import axios from "axios";
import { Liquidacion } from "./compModal/Liquidacion";
import { Facturas } from "./compModal/Facturas";
import { Contratante } from "./Contratante";
import { DocsDigitalTabla } from "../../gen/siniestros/DocsDigitalTabla";
import { Historial } from "../../coms/siniestros/Historial";
import { DeducibleAccordion } from "../../gen/siniestros/compModal/DeducibleAccordion";
import { FormularioZohoVam } from "../zoho/FormularioZohoVam";
import { has_role } from "../../util/General";

export class Detalles extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            value: "",
            editing: false,
            open: false,
            item: {},
            cliente: {},
            hTabs: "ht0",
            beneficios: [],
            documentos: [],
            facturas: [],
            liquidaciones: [],
            docdigital: [],
            docminio: [],
            totalesBeneficio: [],
            deducible: {
                total: 1,
                saldo: 1,
                consumido: 0,
            },
            diasExtra: null,
            historial: [],
            dueDate: "",
            createdTime: "",
        };
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    fetchData() {
        this.getDeducibles(this.props.siniestro.cdCompania, this.props.siniestro.cdAsegurado);
        this.getBeneficios(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getDocumentos(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getFacturas(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getLiquidaciones(this.props.siniestro.cdCompania, this.props.siniestro.cdIncSiniestro);
        this.getDocDigital(this.props.siniestro);
        this.getPoliza();

        let isAm = this.props.siniestro.nmRamo.toLowerCase().indexOf("med") >= 0;

        if (isAm && app.prodeseg) {
            this.getZohoDias();
        }
    }

    getBeneficios = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestro/coberturas", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let bens = resp.data.sort((a1, a2) => a1.cdCobDedSiniestro - a2.cdCobDedSiniestro);

                let totales = {
                    valSiniestro: 0,
                    valExceso: 0,
                    valNoelegible: 0,
                    valCubierto: 0,
                    valDeducible: 0,
                    valFijo: 0,
                };
                bens.forEach(item => {
                    item.valCubierto = item.valSiniestro - item.valMinimo;
                    totales.valSiniestro += item.valSiniestro ? item.valSiniestro : 0;
                    totales.valExceso += item.valExceso ? item.valExceso : 0;
                    totales.valNoelegible += item.valNoelegible ? item.valNoelegible : 0;
                    totales.valCubierto += item.valCubierto ? item.valCubierto : 0;
                    totales.valDeducible += item.valDeducible ? item.valDeducible : 0;
                    totales.valFijo += item.valFijo ? item.valFijo : 0;
                });
                this.setState({ beneficios: bens, totalesBeneficio: totales });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDocDigital = coti => {
        axios
            .get(routes.apiGen + "/docs", {
                params: {
                    tipo: "siniestroVam",
                    cdIncSiniestro: coti.cdIncSiniestro,
                    numSiniestro: coti.numSiniestro + "." + coti.item + "/" + coti.anoSiniestro,
                    cdCliente: coti.cdCliente,
                    cdPoliza: coti.poliza,
                    cdCompania: coti.cdCompania,
                    cdReclamo: coti.cdReclamo,
                },
            })
            .then(resp => {
                let res = resp.data;
                res.minio.map(rp => {
                    rp.metadato = JSON.stringify(rp.metadato);
                });
                this.setState({ docminio: res.minio });
                (res.minio || []).forEach(datosTabla => {
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                    //Se encuentra doble serializado el JSON
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                });
                this.setState({ docdigital: res });
            })
            .catch(error => {
                // alert('Error al consultar' + error);
            });
    };

    getDocumentos = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestro/inspeccion", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let docs = resp.data.sort((a1, a2) => parseInt(a1.item) - parseInt(a2.item));
                this.setState({ documentos: docs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getFacturas = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestro/facturas", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let facts = resp.data;
                this.setState({ facturas: facts });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getLiquidaciones = (idComp, cdIncSiniestro) => {
        axios
            .get(routes.api + "/siniestro/liquidacion", {
                params: {
                    cdCompania: idComp,
                    cdIncSiniestro: cdIncSiniestro,
                },
            })
            .then(resp => {
                let liqs = resp.data;
                this.setState({ liquidaciones: liqs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDeducibles = (cdCompania, cdAsegurado) => {
        axios
            .get(routes.api + "/siniestro/deducible", {
                params: { cdCompania, cdAsegurado },
            })
            .then(resp => {
                let deducible = resp.data;
                this.setState({ deducible });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };
    onClose = () => {
        this.getDocDigital(this.props.siniestro);
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ item: {} });
        this.setState({ historial: [] });
        this.setState({ dueDate: "" });
    };

    tabSelect = tab => {
        this.setState({ hTabs: tab });
    };

    getPoliza = () => {
        axios
            .get(routes.api + "/cliente", {
                params: {
                    cdCliente: this.props.siniestro.cdCliente,
                },
            })
            .then(resp => {
                this.setState({ cliente: resp.data });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getZohoDias = () => {
        let cdIncSiniestro = this.props.siniestro.cdIncSiniestro;
        let cdCompania = this.props.siniestro.cdCompania;
        let numReclamo = this.props.siniestro.numSiniestro + "." + this.props.siniestro.item;
        let anio = this.props.siniestro.anoSiniestro;
        let estado = this.props.siniestro.estado || "-";

        axios
            .post(routes.api + "/zohoDiasMsg", { cdIncSiniestro, cdCompania, numReclamo, anio, estado })
            .then(resp => {
                let tmp = resp.data;
                this.setState({ diasExtra: tmp });
                this.setState({ dueDate: tmp.dueDate });
                this.setState({ createdTime: tmp.createdTime });
                let ht = tmp.historial; //debo ordenar esto
                if (ht) {
                    ht.sort(function (a, b) {
                        return new Date(a.fecha) - new Date(b.fecha);
                    });
                    this.setState({ historial: ht });
                } else {
                    this.setState({ historial: [] });
                }
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    openCollapse = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            siniestro={this.props.siniestro}
                            cliente={this.state.cliente}
                            alert={this.alert.current}
                            diasExtra={this.state.diasExtra}
                            liquidacion={this.state.liquidaciones}
                        />

                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={() => {
                                        this.closeModal();
                                    }}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <h5 className="card-title">Detalle Siniestro</h5>
                            <DeducibleAccordion hTabs={this.state.hTabs} deducibles={this.state.deducible} />
                            <div className="my-1" />
                            <Facturas hTabs={this.state.hTabs} facturas={this.state.facturas} />
                            <div className="my-1" />
                            <Liquidacion hTabs={this.state.hTabs} liquidaciones={this.state.liquidaciones} />
                            <div className="my-1" />
                            <DocsDigitalTabla
                                hTabs={this.state.hTabs}
                                docdigital={this.state.docdigital}
                                docminio={this.state.docminio}
                                dato={this.props.siniestro}
                                tipo={"siniestroVam"}
                                onClose={this.onClose}
                                ocultar={true}
                                eliminar={
                                    has_role(this.props.user, "ROLE_ADMIN") &&
                                    !has_role(this.props.user, "ROLE_USUARIO") &&
                                    has_role(this.props.user, "ROLE_AGENTE")
                                }
                            />
                            <div className="my-1" />
                            <Historial
                                historial={this.state.historial}
                                fecha={this.state.dueDate}
                                aseguradora={this.props.siniestro.nmAseg}
                                creacionFc={this.state.createdTime}
                                siniestro={this.props.siniestro}
                                zohoFormItem={FormularioZohoVam}
                                dato={this.props.siniestro}
                                tipo={"siniestroVam"}
                                onClose={this.onClose}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
